<div *ngIf="isActive" class="tab-item-content">
	<ng-content></ng-content>
</div>
